import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'assesment'
const baseUrl = process.env.REACT_APP_SERVICE_ASSESMENT_URL
const appCode = process.env.REACT_APP_SERVICE_ASSESMENT_APPCODE
const outputType = 'json'
//master
export const standarKompetensiCreate = 'master/CompetencyStandard/create/'
export const standarKompetensiList = 'master/CompetencyStandard/list/'
export const standarKompetensiDetail = 'master/CompetencyStandard/detail/'
export const standarKompetensiDetailStankom = 'master/CompetencyStandard/detail_stankom/'
export const standarKompetensiUpdate = 'master/CompetencyStandard/update/'
export const standarKompetensiInactive = 'master/CompetencyStandard/inactive/'
export const standarKompetensiActive = 'master/CompetencyStandard/active/'
export const kompetensiList = 'master/CompetencyStandard/get_competence/'
export const kompetensiLevel = 'master/CompetencyStandard/get_competencelevel/'

// Manajerial
export const AcManajerialList = '/Transaction/Managerial/list/'
export const AcManajerialCreate = 'Transaction/Managerial/create/'
export const AcManajerialData = 'Transaction/Managerial/acdata/'
export const AcManajerialDetail = 'Transaction/Managerial/acdetail/'
export const AcManajerialUpdate = 'Transaction/Managerial/update/'
export const AcManajerialEmployee = 'Transaction/Managerial/get_employee/'
export const AcManajerialPeriod = 'Transaction/Managerial/get_period/'
export const AcManajerialKinerja = 'Transaction/Managerial/get_performance/'
export const AcManajerialStankom = 'Transaction/Managerial/get_stankom/'
export const AcManajerialEmployeeDetail = 'Transaction/Managerial/get_employeedetail/'
export const AcManajerialLevelCompetence = 'Transaction/Managerial/get_competencelevel/'
export const AcManajerialMatrix = '/Transaction/Managerial/get_matrix/'
export const AcDevGuide = '/Transaction/Managerial/get_devGuide/'
export const SuitablePossision = '/Transaction/Managerial/get_suitableposs/'
// Teknis
export const AcTeknisList = '/Transaction/Teknis/list/'
export const AcTeknisCreate = 'Transaction/Teknis/create/'
export const AcTeknisData = 'Transaction/Teknis/acdata/'
export const AcTeknisDetail = 'Transaction/Teknis/acdetail/'
export const AcTeknisUpdate = 'Transaction/Teknis/update/'
export const AcTeknisEmployee = 'Transaction/Teknis/get_employee/'
export const AcTeknisPeriod = 'Transaction/Teknis/get_period/'
export const AcTeknisKinerja = 'Transaction/Teknis/get_performance/'
export const AcTeknisStankom = 'Transaction/Teknis/get_stankom/'
export const AcTeknisEmployeeDetail = 'Transaction/Teknis/get_employeedetail/'
export const AcTeknisLevelCompetence = 'Transaction/Teknis/get_competencelevel/'
export const AcTeknisMatrix = '/Transaction/Teknis/get_matrix/'
export const AcDevGuideTeknis = '/Transaction/Teknis/get_devGuide/'
export const SuitablePossisionTeknis = '/Transaction/Teknis/get_suitableposs/'
// Sosiocultural
export const AcSosioculturalList = '/Transaction/Sosiocultural/list/'
export const AcSosioculturalCreate = 'Transaction/Sosiocultural/create/'
export const AcSosioculturalData = 'Transaction/Sosiocultural/acdata/'
export const AcSosioculturalDetail = 'Transaction/Sosiocultural/acdetail/'
export const AcSosioculturalUpdate = 'Transaction/Sosiocultural/update/'
export const AcSosioculturalEmployee = 'Transaction/Sosiocultural/get_employee/'
export const AcSosioculturalPeriod = 'Transaction/Sosiocultural/get_period/'
export const AcSosioculturalKinerja = 'Transaction/Sosiocultural/get_performance/'
export const AcSosioculturalStankom = 'Transaction/Sosiocultural/get_stankom/'
export const AcSosioculturalEmployeeDetail = 'Transaction/Sosiocultural/get_employeedetail/'
export const AcSosioculturalLevelCompetence = 'Transaction/Sosiocultural/get_competencelevel/'
export const AcSosioculturalMatrix = '/Transaction/Sosiocultural/get_matrix/'
export const AcDevGuideSosio = '/Transaction/Sosiocultural/get_devGuide/'
export const SuitablePossisionSosio = '/Transaction/Sosiocultural/get_suitableposs/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}